export default "__VITE_ASSET__DrkdAbSb__"